import React from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

export default function withConfirmationMessages(WrappedComponent, messages) {
  return class extends React.Component {
    static propTypes = {
      amount: PropTypes.number,
      confirmationNumber: PropTypes.string,
      giftaidFlag: PropTypes.bool,
      isVoucherFlow: PropTypes.bool,
      orgName: PropTypes.string,
      postBackData: PropTypes.object,
      rp_status: PropTypes.bool,
      signUpStatus: PropTypes.bool,
      receiptId: PropTypes.string,
    };

    getGiftAidConfText = (label) => {
      if (this.props.giftaidFlag) {
        return this.props.rp_status ? label.giftAidRecurring : label.giftAid;
      }
      return '';
    };

    getYourDonationLabel = () => {
      let yourDonation = getContent('locals')('confirmation/confirmation')(
        'label.yourdonation',
        { amount: this.props.amount, orgName: this.props.orgName },
        {
          useHTML: true,
        }
      );
      if (this.props.isVoucherFlow) {
        yourDonation =
          getContent('locals')('confirmation/confirmation')(
            'label.voucher.yourdonation',
            { amount: this.props.amount, orgName: this.props.orgName },
            {
              useHTML: true,
            }
          ) || yourDonation;
      }

      return yourDonation;
    };

    getYourRPDonationLabel = () =>
      getContent('locals')('confirmation/confirmation')(
        'label.yourRPdonation',
        { amount: this.props.amount, orgName: this.props.orgName },
        { useHTML: true }
      );

    getReturnTextLabel = (label) => {
      let returnText = label.returnText;
      returnText =
        returnText && returnText.replace('{orgName}', this.props.orgName);
      return returnText;
    };

    getReturnTextMemberLabel = (label) => {
      let returnTextMember = label.returnTextMember;
      returnTextMember =
        returnTextMember &&
        returnTextMember.replace('{orgName}', this.props.orgName);
      return returnTextMember;
    };

    getReturnToLabel = (label) => {
      let returnTo = label.returnto;
      returnTo = returnTo && returnTo.replace('{orgName}', this.props.orgName);
      return returnTo;
    };

    getTxnIdLabel = (label) => {
      let txnId = label.txnId;
      let id = this.props.rp_status
        ? this.props.confirmationNumber
        : this.props.receiptId;
      id = id || this.props.confirmationNumber;

      txnId = txnId && txnId.replace('{txnId}', id);
      return txnId;
    };

    getSignupProps = (label) => {
      return {
        signUpStatus: this.props.signUpStatus,
        successMessage: label.successMessage,
        failMessage: label.failMessage,
      };
    };

    render() {
      const { label = {} } = messages || {};
      const returnText = this.getReturnTextLabel(label);
      const returnTextMember = this.getReturnTextMemberLabel(label);
      const returnTo = this.getReturnToLabel(label);
      const txnId = this.getTxnIdLabel(label);
      const yourRPdonation = this.getYourRPDonationLabel();
      const giftAidConfText = this.getGiftAidConfText(label);
      const yourDonation = this.getYourDonationLabel();
      const signUpProps = this.getSignupProps(label);
      return (
        <WrappedComponent
          {...this.props}
          label={label}
          messages={messages}
          yourDonation={yourDonation}
          returnText={returnText}
          returnTextMember={returnTextMember}
          returnTo={returnTo}
          txnId={txnId}
          yourRPdonation={yourRPdonation}
          giftAidConfText={giftAidConfText}
          signUpProps={signUpProps}
        />
      );
    }
  };
}
